import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { DigitalWalletService } from '../account/digital-wallet/services/digital-wallet.service';

@Injectable()
export class DashboardResolver  {
    constructor(private router: Router,
                private readonly dwService: DigitalWalletService,
    ) {
    }

    public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return of(true);
    }
}
